export default {
  setData(state, { payload }) {
    state.allData = payload.data.list;
  },
  setFlashErrorMessage(state, payload) {
    state.flashErrorMessage = payload;
    state.flashError = payload !== '';
  },
  clearData(state) {
    state.allData = [];
    state.totalData = 0;
  },
  clearErrors(state) {
    state.errors = [];
  },
  setErrors(state, payload) {
    state.errors = payload;
  },
  setTotalData(state, { payload }) {
    state.totalData = parseInt(payload.data.count_data, 10);
    state.totalPage = parseInt(payload.data.total_page, 10);
  },
  setLoading(state, loading) {
    state.loading = loading;
  },
  setCancelation(state, payload) {
    state.requestData = payload;
  },
  setOnDownloadResult(state, onDownloadResult) {
    state.onDownloadResult = onDownloadResult;
  },
};
